import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import SoundWave from '@components/icons/SoundWave.svg';
import { Footer } from '../Footer';
import { TProps } from './types/TProps';

export const Content = ({ orgName, onAccept }: TProps) => {
  return (
    <div className="content">
      <p>
        You are about to join the organization <b>{orgName}</b>
      </p>
      <Button className="button" onClick={onAccept}>
        Accept
      </Button>
      <div className="text"></div>

      <SoundWave />

      <Footer />
    </div>
  );
};
